import _ from 'lodash'
import React, {useEffect, useState} from 'react'
import {Redirect, withRouter} from 'react-router-dom'
import {withProps} from 'recompose'
import PullToRefresh from "pulltorefreshjs";
import ReactDOMServer from "react-dom/server";
import {BsArrowDownCircleFill} from "react-icons/bs";
import {IoSyncCircle} from "react-icons/io5";
import {IS_CORDOVA} from "../envs/_current/config";


const FixAppNavigation = withRouter(
  ({match, location, history, Routes}) => {
    const [ready, setReady] = useState(
      () => history?.length > 2
    )

    useEffect(() => {
      if (IS_CORDOVA) {
        PullToRefresh.init({
          mainElement: 'body',
          onRefresh() {
            try {
              window.location.reload()
            } catch (e) {
              console.error("window.location.reload() FAILED.", e);
            }
          },
          shouldPullToRefresh() {
            // Kiểm tra nếu modal đang mở
            const isModalOpen = document.querySelector('.SideModal') !== null;
            if (isModalOpen) {
              return false; // Ngăn PullToRefresh nếu modal mở
            }

            return !window.scrollY;
          },
          iconArrow: ReactDOMServer.renderToString(
            <div style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <BsArrowDownCircleFill size={32} color="#007bff"/>
            </div>
          ),
          iconRefreshing: ReactDOMServer.renderToString(
            <div style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <IoSyncCircle size={32} color="#007bff"/>
            </div>
          ),
        });

      }

      return () => {
        // Destroy all instances on unmount to prevent glitches
        if (IS_CORDOVA) {
          PullToRefresh.destroyAll();
        }
      };
    }, []);

    useEffect(() => {
      if (!ready) {
        history.replace({
          pathname: '/',
          state: {
            ready: true,
            location
          }
        })
      }
    }, [history, location, ready])
    const getReady = _.get(
      location,
      'state.ready'
    )
    useEffect(() => {
      if (!ready) {
        if (getReady) {
          setReady(true)
          history.push(
            location.state.location
          )
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getReady])
    if (!ready) return null
    return (
      <Routes
        {...{
          match,
          location,
          history
        }}
      />
    )
  }
)

export const RedirectToModal = withProps(
  props => ({
    to: {
      ...props.location,
      state: {
        isModal: true
      }
    }
  })
)(Redirect)

export default FixAppNavigation
